import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ContactSalesModal from "@/components/ContactSalesModal";

const Book = () => {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  const handleOpenChange = (value: boolean) => {
    setOpen(value);
    if (!value) navigate("/");
  };

  return (
    <div className="min-h-screen bg-background">
      <ContactSalesModal
        open={open}
        onOpenChange={handleOpenChange}
        onConfirmed={() => navigate("/")}
        showBranding
      />
    </div>
  );
};

export default Book;